// src/views/EjecucionesManuales/RecalcularSaldoDeTarjetas/RecalcularSaldoDeTarjetas.jsx
import React from "react";
import EjecutarProceso from "../../EstadosFlujos/Procesos/EjecutarProceso";

export default function RecalcularSaldoDeTarjetas({ onRedirect }) {
  return (
    <EjecutarProceso
      procesoId={8}
      titulo="Recalcular Saldo De Tarjetas"
      redirectView="listaTarjetas"   // ⬅️ EXACTO
      onRedirect={onRedirect}
    />
  );
}
